/* 
Object:         Listbox
Description:    Logic for kendo listboxes
Used in:        Forms or pages with kendo listboxes.
*/

/**
 * Move selection from one list to another 
 * @param {string} listFrom
 * @param {string} listTo
 * @param {string} validationField
 * @param {string} validationText
 */
export function moveItems(listFrom: string, listTo: string, validationField: string, validationText: string) {
    var somethingChanged = false;

    var listBoxFrom = $("#" + listFrom).data("kendoListBox");
    var listBoxTo = $("#" + listTo).data("kendoListBox");

    var selectedItems = listBoxFrom.select();

    for (var i = 0; i < selectedItems.length; i++) {
        var index = listBoxFrom.items().index(selectedItems[i]);
        var item = listBoxFrom.dataSource.view()[index];

        if (!item.Disabled) {
            listBoxTo.dataSource.add({
                Text: item.Text,
                Value: item.Value,
                Type: item.Type,
                UserID: item.UserID,
                GroupID: item.GroupID,
                PreComMsgGroupID: item.PreComMsgGroupID,
                Disabled: item.Disabled
            });

            listBoxFrom.remove(selectedItems[i]);

            somethingChanged = true;
        }
    }

    if (somethingChanged) {
        listBoxFrom.refresh();
        listBoxTo.refresh();

        $(validationField).attr("style", "color:red");
        $(validationField).html(validationText).text();
    }
}

/**
 * Move selection from one list to another 
 * @param {string} listFrom
 * @param {string} listTo
 */
export function removeItems(listFrom: string, listTo: string): void {
    var listBoxFrom = $("#" + listFrom).data("kendoListBox");
    var listBoxTo = $("#" + listTo).data("kendoListBox");

    var selectedFromItems = listBoxFrom.select();
    var selectedToItems = listBoxTo.select();

    for (var i = 0; i < selectedFromItems.length; i++) {
        listBoxFrom.remove(selectedFromItems[i]);
    }
    for (var j = 0; j < selectedToItems.length; j++) {
        listBoxTo.remove(selectedToItems[i]);
    }
}
